import React from 'react';
import { Gallery, Section, SectionSubTitle } from 'common/components';
import { CONSTRUCTION_HOUSES_ELEMENT_BLOCK } from '../../construction-houses-constants';
import { CONSTRUCTION_HOUSES_GALLERY } from './construction-houses-gallery-section-constants';
import { constructionHousesGalleryGrid } from './construction-houses-gallery-section-styles';

export const ConstructionHousesGallerySection: React.FC = () => (
  <Section>
    <SectionSubTitle margin="m">Галерея выполненных работ</SectionSubTitle>
    <Gallery
      elementBlock={CONSTRUCTION_HOUSES_ELEMENT_BLOCK}
      elementText="Галерея выполненных работ"
      imageList={CONSTRUCTION_HOUSES_GALLERY}
      imagePerPage={CONSTRUCTION_HOUSES_GALLERY.length}
      isShowImageName
      galleryGridClassName={constructionHousesGalleryGrid}
    />
  </Section>
);
